<template>
  <el-card v-loading="loading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="登录账号" prop="username">
            <el-input
              placeholder="请输入登录账号"
              v-model="editModel.username"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号昵称" prop="nickname">
            <el-input
              placeholder="请输入账号昵称"
              v-model="editModel.nickname"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input
              type="password"
              :placeholder="
                editModel.guid ? '不修改密码时请留空' : '请输入登录密码'
              "
              v-model="editModel.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="管理角色">
            <el-checkbox
              v-model="editModel.optSuper"
              :true-label="1"
              :false-label="0"
            >
              超级管理员
            </el-checkbox>
          </el-form-item>
          <el-form-item label="权限角色" prop="roleGuid">
            <template v-if="!editModel.optSuper">
              <customer-role-select
                v-model="editModel.roleGuid"
                :defaultFirst="true"
                :customerGuid="editModel.customerGuid"
              />
            </template>
            <template v-else>
              <span style="color: #919191">全部权限</span>
            </template>
          </el-form-item>
          <el-form-item label="其他选项" prop="moreExtras">
            <div class="borderBox">
              <el-checkbox
                v-model="editModel.optMulti"
                :true-label="1"
                :false-label="0"
              >
                多设备同时登录
              </el-checkbox>
              <div style="margin-top: 20px">
                <span>
                  选项说明：
                  <li>
                    <strong>多设备同时登录</strong>
                    <span>
                      启用多端登录功能后，该账号支持同时多设备端登录，但是登录过期时间为1天，为保障安全性，请谨慎启用该功能
                    </span>
                  </li>
                </span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
import customerRoleSelect from '../../../../components/business/customerRoleSelect.vue';
const defaultModel = {
  optMulti: 0,
};

export default {
  components: {
    customerRoleSelect
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        customerGuid: [
          {
            required: true,
            message: "请选择商户",
            trigger: "change",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入登录账号",
            trigger: "change",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入账号昵称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.account.info.update"
            : "biz.customer.account.info.create";
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.customerGuid) {
        this.editModel.customerGuid = this.pageParams.customerGuid;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.editRules.password = [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "change",
          },
        ];
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.account.info.detail", {
          guid: this.pageParams.guid,
        })
          .then((resp) => {
            this.editModel = resp.data;
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg = (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
